import dayjs from 'dayjs';

type DataRange = { min: number; max: number; range: number };

export const getNumberRange = <T>(data: T[], dataKey: keyof T): DataRange => {
  if (data.length === 0) {
    return { min: 0, max: 0, range: 0 };
  }

  let min = Infinity;
  let max = -Infinity;

  for (const item of data) {
    const value = item[dataKey] as number;
    if (value < min) min = value;
    if (value > max) max = value;
  }

  return { min, max, range: max - min };
};

export const getDataRangeInMilliseconds = <T>(
  data: T[],
  unixDataKey: keyof T
): DataRange => {
  if (data.length === 0) {
    return { min: 0, max: 0, range: 0 };
  }

  const { min, max } = data.reduce(
    (acc, item) => {
      const timestamp = item[unixDataKey] as number;
      return {
        min: Math.min(acc.min, timestamp),
        max: Math.max(acc.max, timestamp),
      };
    },
    { min: Infinity, max: -Infinity }
  );

  return {
    min: dayjs.unix(min).valueOf(),
    max: dayjs.unix(max).valueOf(),
    range: dayjs.unix(max).diff(dayjs.unix(min), 'ms'),
  };
};
